import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b98f06e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "申請画面")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"17%"} })
], -1))
const _hoisted_10 = { style: {"height":"40px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請No.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請日", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ステータス", -1))
const _hoisted_14 = { style: {"width":"100%","margin-top":"-5px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" ｱﾄﾞﾚｽ＿申請者名 ")
], -1))
const _hoisted_17 = { colspan: "2" }
const _hoisted_18 = ["readonly"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "※アドレスはそのままで、申請者名を記載ください", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 申請タイトル ")
], -1))
const _hoisted_21 = { colspan: "3" }
const _hoisted_22 = ["readonly"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対応希望日", -1))
const _hoisted_24 = ["max", "readonly"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 申請種別 ")
], -1))
const _hoisted_26 = { colspan: "2" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_31 = { colspan: "3" }
const _hoisted_32 = { class: "form-inline flex-container" }
const _hoisted_33 = {
  class: "form-group",
  style: {"width":"100%","margin-right":"1rem"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "参考：関連情報", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"75%"} })
], -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ワンストップガイド", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "関連資料", -1))
const _hoisted_40 = { class: "osg-files-cell" }
const _hoisted_41 = ["href", "onClick"]
const _hoisted_42 = {
  key: 0,
  class: "sub1"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全データダウンロード", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "添付資料", -1))
const _hoisted_51 = {
  colspan: "3",
  class: "osg-files-cell"
}
const _hoisted_52 = { class: "file-upload" }
const _hoisted_53 = ["accept", "readonly"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "sub1"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, "補足（注意事項）")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対象AGコード", -1))
const _hoisted_61 = { colspan: "2" }
const _hoisted_62 = ["readonly"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対象企業ID", -1))
const _hoisted_64 = ["readonly"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "内容（メモ欄）")
], -1))
const _hoisted_66 = { colspan: "6" }
const _hoisted_67 = ["readonly"]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "カウネット返信欄", -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { key: 2 }
const _hoisted_72 = { colspan: "6" }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "カウネット営業担当", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"70%"} })
], -1))
const _hoisted_76 = { style: {"text-align":"left"} }
const _hoisted_77 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            (_ctx.applicationData.appNo != '')
              ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("td", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appNo), 1)
                      ]),
                      _hoisted_12,
                      _createElementVNode("td", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appDate), 1)
                      ]),
                      _hoisted_13,
                      _createElementVNode("td", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appStatus), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _createElementVNode("td", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtAppUser",
                      maxlength: "50",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.applicationData.appUser) = $event)),
                      ref: "txtAppUser",
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_18), [
                      [_vModelText, _ctx.applicationData.appUser]
                    ])
                  ]),
                  _hoisted_19
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtAppTitle",
                      maxlength: "60",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applicationData.appTitle) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_22), [
                      [_vModelText, _ctx.applicationData.appTitle]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_23,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "wishDate",
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.applicationData.wishDate) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_24), [
                      [_vModelText, _ctx.applicationData.wishDate]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", _hoisted_26, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.applicationData.appCategoryId) = $event)),
                      disabled: !_ctx.enableEdit,
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onCategoryChange && _ctx.onCategoryChange(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appCategoryList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_28))
                      }), 128))
                    ], 40, _hoisted_27), [
                      [_vModelSelect, _ctx.applicationData.appCategoryId]
                    ])
                  ])
                ]),
                (
              _ctx.applicationData.osgCategoryID ||
              _ctx.applicationData?.osgTempFileList.length > 0
            )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("fieldset", null, [
                              _hoisted_34,
                              _createElementVNode("table", null, [
                                _hoisted_35,
                                _createElementVNode("tbody", null, [
                                  (_ctx.applicationData.osgCategoryID)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                        _hoisted_37,
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_router_link, {
                                            class: "com_link1",
                                            to: `/${
                                _ctx.applicationData.osgDetailPath
                              }/categoryId/${
                                _ctx.applicationData.osgCategoryID
                              }/contentsId/${
                                _ctx.applicationData.osgContentsId
                              }/ismodal/${true}`,
                                            target: "_blank",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (
                                _ctx.regLinkClick(
                                  `/${
                                    _ctx.applicationData.osgDetailPath
                                  }/categoryId/${
                                    _ctx.applicationData.osgCategoryID
                                  }/contentsId/${
                                    _ctx.applicationData.osgContentsId
                                  }/ismodal/${true}`
                                )
                              ))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.applicationData.osgContentsTitle), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["to"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.applicationData?.osgTempFileList.length > 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                                        _hoisted_39,
                                        _createElementVNode("td", _hoisted_40, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationData?.osgTempFileList, (tempFile) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: tempFile.rowNo,
                                              class: "osg-file-row"
                                            }, [
                                              _createElementVNode("a", {
                                                href: `/${tempFile.tempFilePath}`,
                                                class: "com_link1",
                                                target: "_blank",
                                                onClick: ($event: any) => (_ctx.regFileLinkClick(tempFile.tempFilePath))
                                              }, _toDisplayString(tempFile.tempFileName), 9, _hoisted_41),
                                              (tempFile.tempFileSize)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, " (" + _toDisplayString(tempFile.tempFileSize) + ")", 1))
                                                : _createCommentVNode("", true),
                                              (tempFile.tempFileName)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    href: "#",
                                                    class: "com_dl_button2 osg-file-row__btn",
                                                    onClick: _withModifiers(($event: any) => (
                                  _ctx.downloadFiles(tempFile.tempFileName)
                                ), ["prevent"])
                                                  }, _hoisted_45, 8, _hoisted_43))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.applicationData?.osgTempFileList.length > 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                                        _hoisted_47,
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            class: "com_dl_button1",
                                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.downloadFiles('')), ["prevent"]))
                                          }, _hoisted_49)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  _createElementVNode("td", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      (_ctx.enableEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (
                    _ctx.onContentsFileUpload(_ctx.AppMgtConstants.TRIGGER_TEMP_FILE)
                  ))
                          }, " + "))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        type: "file",
                        accept: _ctx.tempFileExtensions.join(','),
                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                        ref: "tempFileInput",
                        style: {"display":"none"},
                        readonly: !_ctx.enableEdit
                      }, null, 40, _hoisted_53)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationData.appTempFileList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.rowNo,
                        class: "osg-file-row"
                      }, [
                        (_ctx.enableEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (
                    _ctx.onRemoveContentsFile(
                      item.rowNo,
                      _ctx.AppMgtConstants.TRIGGER_TEMP_FILE
                    )
                  )
                            }, " - ", 8, _hoisted_54))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.fileName) + " ", 1),
                        (item.tempFileSize)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, " (" + _toDisplayString(item.tempFileSize) + ")", 1))
                          : _createCommentVNode("", true),
                        (item.fileName && !item.isUpload)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: "#",
                              class: "com_dl_button2 osg-file-row__btn",
                              onClick: _withModifiers(($event: any) => (_ctx.downloadTempFiles(item.fileName)), ["prevent"])
                            }, _hoisted_58, 8, _hoisted_56))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_59,
                _createElementVNode("tr", null, [
                  _hoisted_60,
                  _createElementVNode("td", _hoisted_61, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtTergetAg",
                      maxlength: "50",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.applicationData.targetAgCode) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_62), [
                      [_vModelText, _ctx.applicationData.targetAgCode]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_63,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtCompanyId",
                      maxlength: "20",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.applicationData.targetCompanyId) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_64), [
                      [_vModelText, _ctx.applicationData.targetCompanyId]
                    ])
                  ])
                ]),
                _hoisted_65,
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_66, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "txtMemo",
                      class: "resizable-textarea",
                      rows: "5",
                      maxlength: "1000",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.applicationData.appMemo) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_67), [
                      [_vModelText, _ctx.applicationData.appMemo]
                    ])
                  ])
                ]),
                (_ctx.applicationData.kaunetComment != '')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_68, _hoisted_70))
                  : _createCommentVNode("", true),
                (_ctx.applicationData.kaunetComment != '')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [
                      _createElementVNode("td", _hoisted_72, [
                        _withDirectives(_createElementVNode("textarea", {
                          id: "txtKaunetComment",
                          class: "resizable-textarea",
                          rows: "5",
                          maxlength: "1000",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.applicationData.kaunetComment) = $event)),
                          readonly: "true"
                        }, null, 512), [
                          [_vModelText, _ctx.applicationData.kaunetComment]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.applicationData.kaunetUser != '')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("td", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.kaunetUser), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("table", null, [
              _hoisted_75,
              _createElementVNode("tbody", null, [
                _createElementVNode("td", _hoisted_76, [
                  (_ctx.isVisibleCancel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnSave",
                        class: "btn btn-footer btn-danger",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                      }, " 取り下げ "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_77, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  (_ctx.isVisibleSave)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnSave",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
                      }, " 一時保存 "))
                    : _createCommentVNode("", true),
                  (_ctx.enableEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        name: "btnApplication",
                        class: "btn btn-footer btn-success",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, " 申請 "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}